import { History } from 'history'
import type { Game } from '@src/components/Game/Game.types'
import { GameType } from '@blackjackfun/ui-components'
import { getGameLink } from '../helper'

// Categories from https://docs.hub88.io/developer-docs/operator-api-reference/games-api
export const getCategoriesForFilter = (selectedCategory: string | null) => {
  switch (selectedCategory) {
    case 'slots':
      return ['Video Slots', 'Jackpot Slots']
    case 'live':
      return ['Live Blackjack', 'Live Baccarat', 'Live Roulette', 'Live Poker', 'Live Dice', 'Live Dragon Tiger']
    case 'blackjack':
      return ['Blackjack', 'Live Blackjack']
    case 'sports':
      return ['Sportsbook']
    case 'gameshows':
      return ['Live Game Shows']
    default:
      return undefined
  }
}

// Reusable function for handling game clicks
export const handleGameClick = (
  game: Game | GameType, 
  history: History, 
  onClose?: () => void
) => {
  if (onClose) {
    onClose()
  }
  const gameLink = getGameLink(game)
  history.push(gameLink)
} 